var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6926_2435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1359 3.27873H28.581V2.8645C28.581 1.56096 27.5204 0.5 26.2165 0.5H2.8645C1.56096 0.5 0.5 1.56057 0.5 2.8645V19.7953C0.5 21.0989 1.56057 22.1598 2.8645 22.1598H3.58756V24.5169C3.58756 25.8205 4.64814 26.8814 5.95206 26.8814H6.66272C7.3823 26.8814 8.08444 27.1763 8.58857 27.6901L12.2109 31.3838C12.2837 31.4578 12.3833 31.5 12.4875 31.5C12.5918 31.5 12.6914 31.4581 12.7642 31.3838L16.3861 27.6901C16.8903 27.1763 17.592 26.8814 18.312 26.8814H29.1363C30.4398 26.8814 31.5004 25.8209 31.5004 24.5169V5.64284C31.5 4.3393 30.4394 3.27873 29.1359 3.27873ZM2.8645 21.3848C1.98798 21.3848 1.27499 20.6718 1.27499 19.7953V2.8645C1.27499 1.98798 1.98798 1.27499 2.8645 1.27499H26.2169C27.0934 1.27499 27.8064 1.98798 27.8064 2.8645V3.27834H5.95206C4.64852 3.27834 3.58756 4.33891 3.58756 5.64284V21.3848H2.8645ZM30.725 24.5169C30.725 25.3935 30.012 26.1065 29.1359 26.1065H18.3116C17.3851 26.1065 16.4815 26.4858 15.8328 27.1477L12.4875 30.5592L9.14192 27.1477C8.49325 26.4862 7.58961 26.1065 6.66311 26.1065H5.95244C5.07593 26.1065 4.36294 25.3935 4.36294 24.5169V5.64284C4.36294 4.76632 5.07593 4.05333 5.95244 4.05333H29.1363C30.0124 4.05333 30.7254 4.76632 30.7254 5.64284L30.725 24.5169Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_6926_2435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6176 20.9663C14.6176 20.6715 14.8566 20.4325 15.1514 20.4325L23.9663 20.4325C24.261 20.4325 24.5 20.6715 24.5 20.9663V20.9663C24.5 21.261 24.261 21.5 23.9663 21.5L15.1514 21.5C14.8566 21.5 14.6176 21.261 14.6176 20.9663V20.9663ZM23.9458 17.5C24.2406 17.5 24.4796 17.739 24.4796 18.0337V18.0337C24.4796 18.3285 24.2406 18.5675 23.9458 18.5675L9.03374 18.5675C8.73896 18.5675 8.5 18.3285 8.5 18.0337V18.0337C8.5 17.739 8.73896 17.5 9.03374 17.5L23.9458 17.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.3824 11.9663C18.3824 11.6715 18.1434 11.4325 17.8486 11.4325L9.03374 11.4325C8.73896 11.4325 8.5 11.6715 8.5 11.9663V11.9663C8.5 12.261 8.73896 12.5 9.03374 12.5L17.8486 12.5C18.1434 12.5 18.3824 12.261 18.3824 11.9663V11.9663ZM9.05418 8.5C8.7594 8.5 8.52044 8.73896 8.52044 9.03374V9.03374C8.52044 9.32852 8.7594 9.56748 9.05418 9.56748L23.9663 9.56748C24.261 9.56748 24.5 9.32852 24.5 9.03374V9.03374C24.5 8.73896 24.261 8.5 23.9663 8.5L9.05418 8.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6926_2435",
    x: 4.5,
    y: 17.5,
    width: 24,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6926_2435"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6926_2435",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6926_2435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.7a7916d2a87fc87302c19eae7f007c63.svg";
export { ForwardRef as ReactComponent };